import { GuardZone } from 'z3k-config';
import { getSharedSensorConfig } from '../../sensors/z3k';
import { selectSensors } from '../../sensors/z3k/utils';
import { removeNulls } from 'utils';
import { fixObjectName } from 'z3k-settings/utils/fix-object-name';
export function getZ3KGuardZones(z3k_config) {
    const guard_zones = GuardZone.get.all(z3k_config);
    const shared_guard_zones = guard_zones.map((guard_zone) => {
        const { relative_sensor_list, name } = guard_zone;
        const z3k_sensors = selectSensors(z3k_config).filter((sensor) => relative_sensor_list.includes(sensor.id));
        const sensors = removeNulls(z3k_sensors.map((sensor, index) => getSharedSensorConfig(sensor, z3k_config, index)));
        return { ...guard_zone, name: fixObjectName(name), sensors };
    });
    return shared_guard_zones;
}
